import { useEffect, useMemo, useRef, useState } from "react";

export default function SearchableSelect({
  options = [],
  value,
  onChange,
  placeholder = "Select…",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef(null);

  const selected = options.find((o) => o.value === value) || null;

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return options;
    return options.filter((o) => (o.label || "").toLowerCase().includes(q));
  }, [options, query]);

  useEffect(() => {
    const onOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    };
    document.addEventListener("mousedown", onOutside);
    return () => document.removeEventListener("mousedown", onOutside);
  }, []);

  const select = (opt) => {
    onChange?.(opt.value);
    setOpen(false);
    setQuery("");
  };

  return (
    <div className={`rtv2-select${open ? " open" : ""}${disabled ? " disabled" : ""}`} ref={wrapRef}>
      <input
        className="rtv2-select-input"
        value={open ? query : (selected?.label || "")}
        placeholder={selected ? "" : placeholder}
        readOnly={!open}
        disabled={disabled}
        onFocus={() => { if (!disabled) setOpen(true); }}
        onMouseDown={(e) => {
          if (disabled) return;
          if (!open) {
            e.preventDefault();
            setOpen(true);
          }
        }}
        onChange={(e) => setQuery(e.target.value)}
      />
      {open && (
        <div className="rtv2-select-drop">
          {filtered.length === 0 ? (
            <div className="rtv2-select-empty">No matches</div>
          ) : (
            filtered.map((opt) => (
              <button
                type="button"
                key={opt.value}
                className={`rtv2-select-opt${opt.value === value ? " on" : ""}`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => select(opt)}
              >
                {opt.label}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
